export default __webpack_public_path__ + "static/inPraiseOfThought-mobile-e267dcb0e06dfc5d7924441175a6f133.svg";